import { ContentPage } from "@/components/marketing/ContentPage";
import { LegalDraftNotice } from "@/components/marketing/LegalDraftNotice";

export function Dpa() {
  return (
    <ContentPage kicker="Legal" title="Data Processing Addendum" lastUpdated="May 25, 2026">
      <LegalDraftNotice />

      <p>
        This Data Processing Addendum ("DPA") forms part of the agreement
        between you ("Customer") and Notamen ("Processor") for use of the
        Service. It describes how we process personal data on your behalf. To the
        extent of any conflict, this DPA governs over the Terms of Service with
        respect to the processing of personal data.
      </p>

      <h2>1. Roles of the parties</h2>
      <p>
        For personal data processed through the Service, the Customer is the{" "}
        <strong>controller</strong> (or processor acting on behalf of its own
        controllers) and Notamen is the <strong>processor</strong>. We
        process personal data only on the Customer's documented instructions,
        including as set out in the Terms of Service and this DPA.
      </p>

      <h2>2. Subject matter and nature of processing</h2>
      <ul>
        <li>
          <strong>Subject matter:</strong> processing necessary to provide the
          Service — generating draft social posts, running safety checks, and
          scheduling and publishing approved posts.
        </li>
        <li>
          <strong>Duration:</strong> for the term of the agreement and any
          retention period described in our Privacy Policy.
        </li>
        <li>
          <strong>Types of data:</strong> account identifiers (such as email
          addresses), brand and content data, and connected-account credentials
          provided by the Customer.
        </li>
        <li>
          <strong>Data subjects:</strong> the Customer's authorized users and
          any individuals referenced in the content the Customer chooses to
          process.
        </li>
      </ul>

      <h2>3. Customer instructions</h2>
      <p>
        We process personal data only to provide and support the Service and as
        otherwise instructed by the Customer in writing. We'll inform the
        Customer if we believe an instruction conflicts with applicable data
        protection law.
      </p>

      <h2>4. Confidentiality</h2>
      <p>
        We ensure that personnel authorized to process personal data are bound
        by appropriate confidentiality obligations.
      </p>

      <h2>5. Security measures</h2>
      <p>
        We maintain the technical and organizational measures described on our{" "}
        <a href="/security">security page</a>, including per-workspace data
        isolation (each row scoped by a workspace key prefix), encryption at
        rest via AWS for DynamoDB and S3, secrets stored in AWS SSM
        SecureStrings, and role-based access controls enforced server-side.
      </p>

      <h2>6. Sub-processors</h2>
      <p>
        The Customer authorizes us to engage the sub-processors listed in our{" "}
        <a href="/legal/privacy">Privacy Policy</a> — currently AWS (hosting,
        storage, authentication, and model inference) and Anthropic (AI model
        provider). We'll impose data protection obligations on sub-processors
        consistent with this DPA and will give notice of changes to the
        sub-processor list so the Customer has an opportunity to object.
      </p>

      <h2>7. Assistance</h2>
      <p>
        Taking into account the nature of the processing, we'll provide
        reasonable assistance to the Customer in responding to data-subject
        requests and in meeting the Customer's security, breach-notification,
        and assessment obligations under applicable data protection law.
      </p>

      <h2>8. Personal data breaches</h2>
      <p>
        We'll notify the Customer without undue delay after becoming aware of a
        personal data breach affecting the Customer's data, and provide
        information reasonably available to us to help the Customer meet its
        notification obligations.
      </p>

      <h2>9. Return and deletion</h2>
      <p>
        On termination of the Service, we'll delete or return the Customer's
        personal data in accordance with our Privacy Policy, except where
        retention is required by law.
      </p>

      <h2>10. International transfers</h2>
      <p>
        Personal data is processed in the AWS us-east-1 region. Where personal
        data is transferred across borders, the parties will rely on an
        appropriate transfer mechanism as required by applicable law [specific
        mechanism to be confirmed in legal review].
      </p>

      <h2>11. Contact</h2>
      <p>
        Questions about this DPA? Email{" "}
        <a href="mailto:privacy@socialmediamanager.pheonixapps.com">
          privacy@socialmediamanager.pheonixapps.com
        </a>
        .
      </p>
    </ContentPage>
  );
}

export default Dpa;
